import { useTranslation } from 'react-i18next';

export default function Garancija() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center cursor-pointer">
              <a href="/" className="flex items-center">
                <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-parking-line text-white text-xl"></i>
                </div>
                <span className="text-xl font-bold text-gray-900">ParkGuard</span>
              </a>
            </div>
            <nav className="hidden md:flex items-center space-x-8">
              <a href="/" className="text-gray-600 hover:text-blue-600 transition-colors font-medium">Početna</a>
              <a href="/#features" className="text-gray-600 hover:text-blue-600 transition-colors font-medium">Proizvod</a>
              <a href="/#faq" className="text-gray-600 hover:text-blue-600 transition-colors font-medium">Česta pitanja</a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-purple-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center bg-green-100 text-green-600 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-shield-check-line mr-2"></i>Garancija
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            2 godine potpune garancije
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Verujemo u kvalitet naših proizvoda i nudimo jednu od najjačih garancija na tržištu
          </p>
        </div>
      </section>

      {/* Warranty Details */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-green-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">2 godine</h3>
              <p className="text-gray-600">Potpuna garancija na sve delove</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-tools-line text-blue-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Besplatno</h3>
              <p className="text-gray-600">Popravka i zamena delova</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-line text-purple-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">24/7</h3>
              <p className="text-gray-600">Tehnička podrška</p>
            </div>
          </div>

          <div className="space-y-8">
            <div className="bg-gray-50 rounded-2xl p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Šta pokriva garancija?</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <i className="ri-check-line text-green-600 text-xl mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">Mehanički delovi</h4>
                      <p className="text-gray-600 text-sm">Motor, zupčanici, ramena barijere</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-check-line text-green-600 text-xl mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">Elektronski delovi</h4>
                      <p className="text-gray-600 text-sm">Kontrolna jedinica, senzori, LED indikatori</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-check-line text-green-600 text-xl mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">Baterija i punjač</h4>
                      <p className="text-gray-600 text-sm">Litijum baterija, solarni panel, punjač</p>
                    </div>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <i className="ri-check-line text-green-600 text-xl mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">Daljinski upravljač</h4>
                      <p className="text-gray-600 text-sm">RF daljinski, rezervni daljinski</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-check-line text-green-600 text-xl mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">Softver i aplikacija</h4>
                      <p className="text-gray-600 text-sm">Mobilna aplikacija, firmware ažuriranja</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-check-line text-green-600 text-xl mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">Instalacijski materijal</h4>
                      <p className="text-gray-600 text-sm">Vijci, ankeri, kablovi</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-blue-50 rounded-2xl p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Uslovi garancije</h2>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <i className="ri-information-line text-blue-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Normalno korišćenje</h4>
                    <p className="text-gray-600">Garancija važi za normalno korišćenje u skladu sa uputstvom za upotrebu.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-information-line text-blue-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Originalni delovi</h4>
                    <p className="text-gray-600">Korišćenje samo originalnih delova i pribora.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-information-line text-blue-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Redovno održavanje</h4>
                    <p className="text-gray-600">Sprovođenje preporučenog održavanja prema uputstvu.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-red-50 rounded-2xl p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Šta ne pokriva garancija?</h2>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <i className="ri-close-line text-red-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Mehanička oštećenja</h4>
                    <p className="text-gray-600">Oštećenja nastala udarom, padom ili vandalizmom.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-close-line text-red-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Prirodne nepogode</h4>
                    <p className="text-gray-600">Oštećenja nastala zbog poplava, zemljotresa, munje.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-close-line text-red-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Neovlašćene izmene</h4>
                    <p className="text-gray-600">Modifikacije ili popravke od strane neovlašćenih lica.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-green-50 to-blue-50 rounded-2xl p-8 border border-green-200">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Kako aktivirati garanciju?</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-green-600 font-bold">1</span>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">Registrujte proizvod</h4>
                  <p className="text-gray-600 text-sm">Popunite garancijski list ili registrujte online</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-blue-600 font-bold">2</span>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">Sačuvajte račun</h4>
                  <p className="text-gray-600 text-sm">Čuvajte originalni račun kao dokaz o kupovini</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-purple-600 font-bold">3</span>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">Kontaktirajte nas</h4>
                  <p className="text-gray-600 text-sm">U slučaju problema, pozovite našu podršku</p>
                </div>
              </div>
            </div>

            <div className="text-center">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Potrebna vam je pomoć?</h2>
              <p className="text-gray-600 mb-8">Naš tim za podršku je dostupan 24/7 za sva vaša pitanja o garanciji</p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a 
                  href="tel:+381612929053"
                  onClick={() => {
                    if (typeof window !== 'undefined') {
                      window.dataLayer = window.dataLayer || [];
                      window.dataLayer.push({ event: 'contact_click', method: 'phone' });
                    }
                  }}
                  className="bg-blue-600 text-white px-8 py-3 rounded-xl hover:bg-blue-700 transition-colors font-medium"
                >
                  <i className="ri-phone-line mr-2"></i>061 29 29 053
                </a>
                <a 
                  href="mailto:maxiorars@gmail.com"
                  className="bg-white text-blue-600 border border-blue-600 px-8 py-3 rounded-xl hover:bg-blue-50 transition-colors font-medium"
                >
                  <i className="ri-mail-line mr-2"></i>maxiorars@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="text-center">
            <div className="flex items-center justify-center mb-4">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-parking-line text-white text-xl"></i>
              </div>
              <span className="text-xl font-bold">ParkGuard</span>
            </div>
            <p className="text-gray-400 mb-6">
              Pametna rešenja za zaštićeno parkiranje. Vaše parking mesto, vaša kontrola.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}